import React from "react";
import Carousel from "react-multi-carousel";
import VideoCard from "./VideoCard";

const VideoCarousel = ({ videoUrls }) => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 2,
      partialVisibilityGutter: 60,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2,
      partialVisibilityGutter: 60,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      partialVisibilityGutter: 40,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      partialVisibilityGutter: 30,
    },
  };

  return (
    <Carousel
      responsive={responsive}
      className="video-list"
      itemClass="videoItem"
      additionalTransfrom={0}
      arrows={true}
      draggable
      partialVisible
      focusOnSelect={false}
    >
      {videoUrls.map((url, index) => (
        <VideoCard key={index} videoUrl={url} />
      ))}
    </Carousel>
  );
};

export default VideoCarousel;
